import { type Experiment } from 'src/types/experiment';
import { dataDog } from 'src/utils/datadog/data-dog';

export async function initializeDatadog(
  type: 'widgets' | 'webview',
  experiments: Experiment[] = []
) {
  const experimentRecord: Record<string, string> = {};

  experiments.forEach((experiment) => {
    experimentRecord[experiment.name] = experiment.value;
  });

  await dataDog.init(type, experimentRecord);
}
